import React from 'react';
import './CompositeFillingContent.css'; // Assuming you have a CSS file for styling

/* Reusing the same CSS file as CompositeFillingContent */
const PFMContent = () => {
  return (
    <div className="composite-fillings">
      <div className="composite-fillings-overview-container">
          <div className="composite-fillings-overview-info">
            <h2 className="composite-fillings-overview-header">Crowns</h2>
            <div className="composite-fillings-custom-line"></div>
            <p className="composite-fillings-text">A crown (or cap) is a covering that encases the entire tooth surface restoring it to its original shape and size.  A crown protects and strengthens tooth structure that cannot be restored with fillings or other types of restorations.</p>
            <p className="composite-fillings-text">Although there are several types of crowns, porcelain (tooth colored crown) are the most popular, because they resemble your natural teeth.  They are highly durable and will last many years, but like most dental restorations, they may eventually need to be replaced.  Porcelain crowns are made to match the shape, size, and color or your teeth giving you a natural, long-lasting beautiful smile.</p>
          </div>

          <div className="composite-fillings-image-container">
            <img 
              src="/images/pfm.jpeg" 
              alt="Crowns" 
              className="composite-fillings-1"
            />
          </div>
      </div>

      <div className="composite-fillings-description-container">
        <div className="composite-fillings-reasons-container">
          <h3 className="composite-fillings-reasons-header">Reasons for Crowns</h3>
          <ul className="composite-fillings-reasons-list">
            <li>Broken or fractured teeth</li>
            <li>Cosmetic enhancement</li>
            <li>Decayed teeth</li>
            <li>Fractured fillings</li>
            <li>Large fillings</li>
            <li>Tooth has a root canal</li>
          </ul>
        </div>

        <div className="composite-fillings-steps-container">
          <h3 className="composite-fillings-steps-header">What does getting a crown involve?</h3>
          <p className="composite-fillings-steps-text">A crown procedure usually requires two appointments.  Your first appointment will include taking several highly accurate molds (or impressions) that will be used to create your custom crown.  A mold will also be used to create a temporary crown which will stay on your tooth for approximately two weeks until your new crown is fabricated by a dental laboratory.</p>
          <p className="composite-fillings-steps-text">While the tooth is numb, the dentist will prepare the tooth by removing any decay and shaping the surface to properly fit the crown.  Once these details are accomplished, your temporary crown will be placed with temporary cement and your bite will be checked to ensure you are biting properly.</p>
          <p className="composite-fillings-steps-text">At your second appointment your temporary crown will be removed, the tooth will be cleaned, and your new crown will be carefully placed to ensure the spacing and bite are accurate. You will be given care instructions and encouraged to have regular dental visits to check your new crown.</p>
        </div>

      </div>
    </div>
  );
};

export default PFMContent;